import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 3a1 1 0 0 1 1 1v2.268a2 2 0 0 1 0 3.464v1.536a2 2 0 0 1 0 3.464v2.854l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 17.586v-2.854a2 2 0 0 1 0-3.464V9.732a2 2 0 0 1 0-3.464V4a1 1 0 0 1 1-1"
    }
  )
);
var SvgTimelineFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TimelineFilled_default = SvgTimelineFilled;

export { TimelineFilled_default as default };
